import { render } from "./page3.vue?vue&type=template&id=34ffc993&scoped=true"
import script from "./page3.vue?vue&type=script&lang=js"
export * from "./page3.vue?vue&type=script&lang=js"

import "./page3.vue?vue&type=style&index=0&id=34ffc993&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ffc993"]])

export default __exports__